import type { ParameterDictionary, WorkbookFilter } from "../../../../../../api/types/workbookRuns.types";
import WorkbookFilterItemDate from "./WorkbookFilterItemDate";
import WorkbookFilterItemText from "./WorkbookFilterItemText";

interface Props {
  filter: WorkbookFilter;
  showCompanyLogo: boolean;
  onUpdateDateFilterValue: (filterValue: string, isValid: boolean) => void;
  onUpdateTextFilterValue: (values: ParameterDictionary[]) => void;
}

const WorkbookFilterItem = ({ filter, showCompanyLogo, onUpdateDateFilterValue, onUpdateTextFilterValue }: Props) => {
  if (filter.type === "Date") {
    return <WorkbookFilterItemDate filter={filter} onUpdateFilterValue={onUpdateDateFilterValue} />;
  }

  if (filter.type === "Table") {
    return (
      <WorkbookFilterItemText
        filter={filter}
        showCompanyLogo={showCompanyLogo}
        onUpdateFilterValue={onUpdateTextFilterValue}
      />
    );
  }

  return null;
};

export default WorkbookFilterItem;
